import axios from "lib/axios";

export const uploadFileApi = async (buildingStructureId, data) => {
  return await axios.post(`/api/building_structures/${buildingStructureId}/building_units/upload_csv`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const batchCreateBuildingUnitApi = async (buildingStructureId, data) => {
  return await axios.post(`/api/building_structures/${buildingStructureId}/building_units/batch_create`, data)
}
